module.exports = __webpack_public_path__ + "img/sixpackcarrier26.1a42bc88.jpg";